import { Stack, Typography } from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';

const DocumentVaultTagEmptyState = () => {
  const { t } = useLocalization();

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      spacing={1}
      sx={{
        minHeight: 240,
        px: 3,
        py: 6,
        textAlign: 'center',
        opacity: 1,
        transition: 'opacity 0.2s ease',
      }}
    >
      <Typography variant='h6'>
        {t('documentVault.noDocumentsFound')}
      </Typography>
      <Typography
        color='text.secondary'
        sx={{ maxWidth: 420 }}
      >
        {t('documentVault.noDocumentsForSelectedTag')}
      </Typography>
    </Stack>
  );
};

export default DocumentVaultTagEmptyState;
